import { api } from '../platform/index.ts';

/**
 * The chat's "📊 Generate dashboard" on cortex: builds a LIVE dashboard from a report's charts (every
 * chart that carries its SELECT becomes a tile that re-runs it on each open, cortex's reports module) and
 * opens it once in a new tab. Answers its page path.
 */
export async function generateDashboard(
  slug: string,
  branch: string,
  { title, charts }: { title: string; charts: Record<string, unknown>[] },
): Promise<string> {
  const tiles = charts
    .filter((c) => typeof c.sql === 'string' && (c.sql as string).trim())
    .slice(0, 50)
    .map((c, i) => {
      const t = String(c.title ?? `Chart ${i + 1}`).slice(0, 200);
      const spec =
        c.type === 'chart' && c.spec && typeof c.spec === 'object'
          ? (c.spec as Record<string, unknown>)
          : { type: 'table', title: t };
      return { id: `t${i + 1}`, title: t, query: { sql: String(c.sql) }, chart: spec, width: 2 };
    });
  if (!tiles.length) throw new Error('no chart carries its SQL');
  const cleanTitle = (title || 'Dashboard').replace(/\s+/g, ' ').trim().slice(0, 140) || 'Dashboard';
  const name =
    (cleanTitle
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 40) || 'dashboard') + `_${Date.now().toString(36)}`;
  const r = await api.PUT('/api/reports/projects/{slug}/branches/{branch}/dashboards/{name}', {
    params: { path: { slug, branch, name } },
    body: { definition: { title: cleanTitle, columns: 2, tiles } },
  });
  if (!r.response.ok) {
    const e = r.error as { message?: string } | undefined;
    throw new Error(e?.message || `HTTP ${r.response.status}`);
  }
  const path = `/p/${encodeURIComponent(slug)}/b/${encodeURIComponent(branch)}/reports?dashboard=${encodeURIComponent(name)}`;
  window.open(path, '_blank', 'noopener');
  return path;
}
